import { render, staticRenderFns } from "./CartCost.vue?vue&type=template&id=9858e118&"
import script from "./CartCost.vue?vue&type=script&lang=js&"
export * from "./CartCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports